import { render } from "./ColourPickerPlaceholders.vue?vue&type=template&id=d5eae3ea&scoped=true"
import script from "./ColourPickerPlaceholders.vue?vue&type=script&lang=js"
export * from "./ColourPickerPlaceholders.vue?vue&type=script&lang=js"

import "./ColourPickerPlaceholders.vue?vue&type=style&index=0&id=d5eae3ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5eae3ea"]])

export default __exports__